import react, { useEffect, useState, useMemo, useRef } from "react";
import { useExam } from "../context/ExamContext";
import {
  useGetExam,
  useGetOngoingExam,
  useGetSectionPracticeTest,
  useGetPracticeTest,
} from "../services/index";
import { useCountdown } from "../hooks/useCountdown";
import { useInitializeExamResources } from "./useInitializeExamResources";
import { useExamServerDataOperations } from "./useExamServerDataOperations";
import { useGetSessionDetails, useCreateInstantExamSchedule } from "../services/index";
import demoExamData from "../demoExam.json";
import { useExamHeartbeat } from "./useExamHeartbeat";
import {
  getExamAndSchedules,
  manageExamSections,
  clearFinishedExamDataFromBrowser,
  clearSectionAnswersFromBrowser,
  clearListeningAudioFromIndexDB,
} from "../services/examService";

export function useManageExam() {
  const [hasFetchedSchedule, setHasFetchedSchedule] = useState(false);
  const [loadingListeningAudio, setLoadingListeningAudio] = useState(false);
  const [examAndSchedules, setExamAndSchedules] = useState()
  const countingTimeLeft = useCountdown();
  const {
    timeLeft,
    isSectionPractice,
    isPractice,
    isRealExam,
    examType,
    updateStageTimeLeft,
    activeView,
    updateActiveView,
    isDemoExam,
    isInstantExam,
    productId,
    uprId,
    setExamType,
    setInstantExamData,
    productType,
    isManualSubmit,
    setIsManualSubmit,
  } = useExam(null);
  const triggerServerDataUpdate = useExamServerDataOperations();

  const { isSessionStarted, finishSession } = useExamHeartbeat({
    enabled: Boolean(uprId) && !isDemoExam,
    isInstantExam: isInstantExam,
  });

  // const { isSessionStarted } = useExamHeartbeat({
  //   enabled:
  //     ["reading", "listening", "writing"].includes(activeView) && !isDemoExam,
  // });

  // const { triggerCreateInstantExamSchedule, isLoadingCreateInstantExamSchedule } =

  const { exam, isLoadingExam, isSuccessExam } =
    useGetExam(isSessionStarted && !isSectionPractice, productId);


  // useEffect(() => {
  //   if (exam) {
  //     console.log(exam.examType);
  //     console.log(isLoadingExam);
  //     console.log(isSuccessExam);

  //     setExamType(exam.examType)
  //   }
  // }, [isSuccessExam]);

  useEffect(() => {
    if (exam) {
      setExamType(exam.examType);
      setInstantExamData(exam.examType === "paid-instant");
    }
  }, [isSuccessExam]);


  const {
    triggerCreateInstantExamSchedule,
    createdInstantExamSchedule,
    isLoadingCreateInstantExamSchedule,
  } = useCreateInstantExamSchedule(uprId);

  const hasTriggeredCreateRef = useRef(false);

  useEffect(() => {

    if (isSessionStarted && !isLoadingExam && uprId && !hasTriggeredCreateRef.current) {

      if (isInstantExam) {
        hasTriggeredCreateRef.current = true;
        triggerCreateInstantExamSchedule();
      }
    }
  }, [isSessionStarted, uprId, isLoadingExam, isInstantExam, triggerCreateInstantExamSchedule]);


  // WE GET THAT TO UNDERSTAND WHICH INTRO SECTION WE MUST SHOW TO USER WHEN PAGE LOADS AND RELOADS
  useEffect(() => {
    if (!isSessionStarted || !examType || isLoadingExam || isDemoExam || isPractice || isSectionPractice)
      return;

    let cancelled = false;

    (async () => {
      const response = await getExamAndSchedules(updateActiveView);
      if (!cancelled) {
        setExamAndSchedules(response)
        setHasFetchedSchedule(response.status === 200);
      }
    })();

    return () => { cancelled = true; };
  }, [isSessionStarted, examType, isLoadingExam]);

  // For practice/section-practice exams: skip the schedule API but still unlock the auto-process.
  // Section practice uses productType (set immediately), so it doesn't need examType.
  // Full practice waits for examType to be set from the fetched exam.
  useEffect(() => {
    if (!isSessionStarted || isDemoExam) return;
    if (isSectionPractice) {
      setHasFetchedSchedule(true);
      return;
    }
    if (!examType || isLoadingExam) return;
    if (!isPractice) return;
    setHasFetchedSchedule(true);
  }, [isSessionStarted, examType, isLoadingExam, isDemoExam, isPractice, isSectionPractice]);




  // Bug Fix #2: Enable session details for ALL exam types (not just practice)
  // Previously: !isRealExam && Boolean(uprId) - this disabled tab lock for real exams
  // Fixed: !isDemoExam && Boolean(uprId) - enable for all non-demo exams with uprId
  const sessionDetailsEnabled = !isDemoExam && Boolean(uprId);

  const { sessionDetails, isLoadingSessionDetails, errorSessionDetails } =
    useGetSessionDetails(sessionDetailsEnabled, uprId);


  const { ongoingExam, isLoadingOngoingExam, errorOngoingExam } =
    useGetOngoingExam(!isDemoExam && hasFetchedSchedule && !isSectionPractice,
      productId);

  const { practiceExamData, isLoadingPracticeExamData, errorPracticeExamData } =
    useGetPracticeTest(!isDemoExam && isPractice, productId);

  const {
    sectionPracticeTestData,
    isLoadingSectionPracticeTest,
    errorSectionPracticeTest,
  } = useGetSectionPracticeTest(
    !isDemoExam && isSectionPractice,
    productType,
    productId
  );

  //**USEEFFECTS**
  // NOTE: useExamSessionProtector removed - heartbeat now handled by WebSocket (useExamTabLock)
  const isLoadingData =
    isLoadingSectionPracticeTest ||
    isLoadingSessionDetails ||
    isLoadingOngoingExam ||
    isLoadingCreateInstantExamSchedule ||
    isLoadingPracticeExamData;

  //For Automated Process  
  useEffect(() => {
    if (!hasFetchedSchedule) return;

    if (isLoadingData) return;

    if (isInstantExam && !createdInstantExamSchedule) return;

    if (countingTimeLeft === 0) {
      manageExamSections(
        updateActiveView,
        updateStageTimeLeft,
        isDemoExam,
        productType,
        activeView,
        examType,
        isManualSubmit,
        setIsManualSubmit,
        examAndSchedules
      );
      triggerServerDataUpdate();
    }
  }, [hasFetchedSchedule, countingTimeLeft, isLoadingData]);


  //For Manual Submit
  // useEffect(() => {
  //   // if (!hasFetchedSchedule && isRealExam) return;
  //   if (isLoadingData) return; // <--- Guard clause
  //   if (countingTimeLeft > 0) {
  //     manageExamSections(
  //       updateActiveView,
  //       updateStageTimeLeft,
  //       isDemoExam,
  //       productType,
  //       examType,
  //       activeView,
  //       isManualSubmit,
  //       setIsManualSubmit
  //     );
  //   }
  // }, [isManualSubmit, isLoadingData]);


  //WE CHECK THAT TO UNDERSTAND WHICH INTRO SECTION WE MUST SHOW TO USER WHEN PAGE LOADS AND RELOADS
  useEffect(() => {

    if (!hasFetchedSchedule && isRealExam) return;


    if (activeView == "readingIntro") {

      clearSectionAnswersFromBrowser("listening");
      clearListeningAudioFromIndexDB(uprId);
    }
    if (activeView == "writingIntro") {
      clearSectionAnswersFromBrowser("reading");
    }
    if (activeView == "examFinish") {
      clearSectionAnswersFromBrowser("writing");
      clearFinishedExamDataFromBrowser();
    }
  }, [hasFetchedSchedule, activeView]);

  const examDataToInit = useMemo(() => {
    if (isLoadingData) return null;
    if (isDemoExam) return demoExamData;
    if (isSectionPractice) return sectionPracticeTestData ?? null;
    if (isPractice) return practiceExamData ?? null;
    return ongoingExam ?? null;
  }, [
    isLoadingData,
    isDemoExam,
    isSectionPractice,
    isPractice,
    sectionPracticeTestData,
    practiceExamData,
    ongoingExam,
  ]);

  const isInitReady = useMemo(() => {
    if (!activeView) return false;
    if (!examDataToInit) return false;
    if (!isDemoExam && !uprId) return false;
    return true;
  }, [activeView, examDataToInit, isDemoExam, uprId]);

  // Bug Fix #3: Get reset function to allow re-initialization after takeover
  const { resetInitialization } = useInitializeExamResources(
    isInitReady ? examDataToInit : null,
    activeView,
    setLoadingListeningAudio,
    isDemoExam
  );


  return {
    activeView,
    isDemoExam,
    timeLeft,
    ongoingExam,
    isLoadingData,
    isLoadingSessionDetails,
    loadingListeningAudio,
    isLoadingOngoingExam,
    sessionDetails,
    errorOngoingExam,
    finishSession,
    resetInitialization, // Bug Fix #3: Expose for takeover success
  };
}
